import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollContainerComponent } from './scroll-container.component';



@NgModule({
  declarations: [
    ScrollContainerComponent
  ],
  exports: [
    ScrollContainerComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ScrollContainerModule { }
